import React from 'react'
import { BUS_RESULT, BusResultCard } from '../BusResults'
import SeatBookingPanel from './SeatBookingPanel'

// Standalone version of the Cancellation view — kept for direct
// linking/preview, mirroring busBoardingPage.jsx / busPhotosPage.jsx / busRatingPage.jsx.
const BusCancelPage = () => {
    return (
        <>
            <section className='commonTopPadding commonBottomPadding'>
                <div className='container'>
                    <div className='row g-4'>
                        <div className='col-md-12'>
                            <BusResultCard item={BUS_RESULT} />
                            <SeatBookingPanel initialTab='cancellation' />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default BusCancelPage
